var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"text-center"},[_c('i',{staticClass:"fa fa-spinner fa-spin fa-4x"})])}
var staticRenderFns = []

export { render, staticRenderFns }